import { render } from "./ChoiceLanguage.vue?vue&type=template&id=79c4b3e3&scoped=true"
import script from "./ChoiceLanguage.vue?vue&type=script&lang=js"
export * from "./ChoiceLanguage.vue?vue&type=script&lang=js"

import "./ChoiceLanguage.vue?vue&type=style&index=0&id=79c4b3e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c4b3e3"]])

export default __exports__